<template>
  <ODataTable class="dense-table" :spec="spec" :items="filteredRows" />
</template>

<script>
import { crayon } from 'oderon-vue/utils'

export default {
  components: {
    ODataTable: require('oderon-vue/cpts/ODataTable').default
  },
  props: {
    keywords: {},
    originJson: { required: true }
  },
  data() {
    return {
      spec: [
        { t: 'Pos.|', d: '$index', f: crayon.grey, w: 50 },
        { t: 'ID|', d: 'id', w: 50 },
        { t: 'Nome', d: 'name' }
      ]
    }
  },
  computed: {
    filteredRows() {
      let rows = this.originJson
      if (this.keywords == null) return rows

      return rows.filter(row => {
        return JSON.stringify(row)
          .toLowerCase()
          .includes(this.keywords.toLowerCase())
      })
    }
  }
}
</script>

<style></style>
